const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EPIRB_PROGRAMMED_TYPES_RETRIEVED":
            return action.epirbProgrammeds;

        default:
            return state;
    }
}
